import { ISbStoryData } from "@storyblok/react/rsc";
import { createLogger } from "./logger";
import { stringLinkResolver } from "./storyblok";
import { checkEnvironmentVariable } from "./utilities";

const logger = createLogger();

const optimizeImage = (image?: string) => {
  return image ? `${image}/m/1200x630/filters:quality(80)` : undefined;
}


// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getStoryblokSeoParameters = (story: ISbStoryData<any>) => {
  checkEnvironmentVariable("NEXT_PUBLIC_BASE_URL");

  if (!story.content?.seo) {
    logger.warn("[SEO] - Story has no SEO content");
    return {};
  }


  const title = story.content?.seo?.title || story.name;
  const description = story.content?.seo?.description;
  const twitterTitle = story.content?.seo?.twitter_title || title;
  const twitterDescription =
    story.content?.seo?.twitter_description || description;
  const ogTitle = story.content?.seo?.og_title || title;
  const ogDescription = story.content?.seo?.og_description || description;

  const canonicalSlug = stringLinkResolver(story.full_slug);


  return {
    metadataBase: new URL(process.env.NEXT_PUBLIC_BASE_URL ?? ""),
    title: title,
    alternates: {
      canonical: `${process.env.NEXT_PUBLIC_BASE_URL}${canonicalSlug === "/" ? "" : canonicalSlug}`,
    },
    description: description,
    robots: {
      index: story.content?.index ?? true,
      follow: story.content?.follow ?? true,
    },
    openGraph: {
      title: ogTitle,
      description: ogDescription,
      url: stringLinkResolver(story.full_slug),
      images: [
        {
          url:
            optimizeImage(story.content?.seo?.og_image) ??
            optimizeImage(story.content?.seo?.twitter_image) ??
            "/og-image.png",
          width: 1200,
          height: 630,
          alt: title,
        },
      ],
    },
    twitter: {
      card: "summary_large_image",
      title: twitterTitle,
      description: twitterDescription,
      images: [
        {
          url:
            optimizeImage(story.content?.seo?.twitter_image) ??
            optimizeImage(story.content?.seo?.og_image) ??
            "/og-image.png",
          width: 1200,
          height: 630,
          alt: title,
        },
      ],
    },
  };
};
